module.exports = __webpack_public_path__ + "static/img/icon_truck.30ce01b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_truck.png
// module id = kweT
// module chunks = 1